import { render, staticRenderFns } from "./transmitters.vue?vue&type=template&id=6c5220ac"
import script from "./transmitters.vue?vue&type=script&lang=js"
export * from "./transmitters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports